module.exports = __webpack_public_path__ + "media/images/landing/main_bubles-436a9f5dba253a206e5658a3955ee186.svg";